import { gql } from "urql"
import { RESULT_BASE_FRAG } from "~/graphql/quality/result.gql"
import { BASE_USER_FRAG } from "./base_user.gql"
import { EXPENSE_FRAG } from "./expense.gql"

export const ADVANCE_PAYMENT_FRAG = /* GraphQL */ `
  fragment AdvancePayFrag on advance_payment {
    id
    parameter {
      id
      name
    }
    transactions {
      created_at
      remark
      trade {
        id
        kind
      }

      date
      amount
      mode {
        name
      }
      transaction_id
      account_no
      amount
    }
    amount
    bourn_by
    user_id
    is_verified
    created_at
  }
`
export const CREDIT_NOTE_FRAG = /* GraphQL */ `
  fragment CreditNoteFrag on credit_note {
    id
    amount
    remarks
    user_id
    is_verified
    created_at
  }
`

export const TRADE_DETAIL_FRAG = /* GraphQL */ `
  fragment TradeDetailFrag on trade {
    id
    status: current_status_id
    is_intercompany_transaction
    tracking_code
    advance_po
    material_kind
    seller_bifurcation {
      advance_amount {
        op
        val
      }
    }
    settled_by_advance_payment: transactions(
      where: { ref: { _eq: "settled_by_advance_payment" } }
    ) {
      id
      ref
      amount
      parent_transaction {
        advance_payment {
          id
          trade {
            id
            kind
          }
        }
      }
    }
    over_due_approval {
      id
    }
    over_draft {
      id
      status
      logs(order_by: { created_at: desc }, limit: 1) {
        id
        status
        user {
          id
          name
        }
      }
    }
    storage_location {
      id
      name
      codename
      storage_location_agreements(
        limit: 1
        where: { is_active: { _eq: true }, is_verified: { _eq: true } }
      ) {
        id
        end_date
      }
    }
    storage_sub_location {
      id
      name
      codename
    }
    officer {
      id
      user {
        ...BaseUserFrag
      }
    }
    junior_officer {
      id
      user {
        ...BaseUserFrag
      }
    }
    status_processing
    receipt_id
    trip {
      id
    }
    department {
      id
      name
      reference_id
    }
    invoice {
      id
    }
    vehicle {
      id
      name
      codename: reference_id
    }
    trades(
      where: { kind: { _in: ["final", "inward", "booking"] } }
      order_by: { created_at: desc_nulls_last }
    ) {
      id
      kind
      start_date
    }
    demand_id
    offer_id
    parent_trade {
      id
      kind
      start_date
      demand_id
      offer_id
      is_multiple_commodity
      officer {
        id
        user {
          ...BaseUserFrag
        }
      }
      junior_officer {
        id
        user {
          ...BaseUserFrag
        }
      }
    }
    buyer {
      id
      credits(where: { status_id: { _eq: "Active" } }) {
        over_drafts_aggregate(
          where: {
            status: { _nin: ["Deviation Approved", "Deviation Rejected"] }
          }
        ) {
          aggregate {
            count
          }
        }
      }
      user {
        ...BaseUserFrag
      }
    }
    seller {
      id
      user {
        ...BaseUserFrag
      }
    }
    commodity {
      id
      commodity {
        ...KiteCommodityFrag
      }
    }
    commodity_variety {
      id
      commodity_variety {
        ...KiteCommodityVarietyFrag
      }
    }
    facilitator {
      id
      facilitator {
        id
        name
        codename
      }
    }
    plot_crop {
      id
      plot_crop {
        id
        external_reference_id
        tag
        name
        codename
      }
    }
    attachments {
      id
      media {
        id
        etag
        url
        key
        kind
      }
    }
    standard_deduction
    start_date
    end_date
    expiry
    packaging
    seller_tnc
    buyer_tnc
    seller_verification
    buyer_verification
    mode
    kind
    total_amount
    total_quantity
    deducted_amount
    supplier_charge
    seller_tds
    seller_tds_percentage
    buyer_expense_amount
    seller_expense_amount
    seller_payable
    buyer_payable
    deducted_quantity
    expense_amount
    is_multiple_commodity
    #supplier_gst_auto_calculated
    #buyer_gst_auto_calculated
    trade_items_aggregate {
      aggregate {
        sum {
          returned_quantity
        }
      }
    }
    trade_items {
      id
      batch_number
      result {
        id
        codename
        result {
          ...ResultBaseFrag
        }
      }
      quantity
      quantity_unit {
        id
        si_unit {
          id
          name
          codename
          base_conversion
        }
      }
      commodity {
        id
        commodity {
          ...KiteCommodityFrag
        }
      }
      commodity_variety {
        id
        commodity_variety {
          ...KiteCommodityVarietyFrag
        }
      }
      plot_crop {
        id
        plot_crop {
          id
          external_reference_id
          tag
          name
          codename
        }
      }
      variety_grade {
        id
        variety_grade {
          id
          name
          codename
        }
      }
      rate
      total_amount: amount
      daily_rate
      rate_unit {
        id
        si_unit {
          id
          name
          codename
          base_conversion
        }
      }
      supplier_gst_auto_calculated
      buyer_gst_auto_calculated
      taxes {
        id
        amount
        role
        percentage
        tax_name
      }
    }
    expenses {
      ...ExpenseFrag
    }
    advance_payments {
      ...AdvancePayFrag
    }
    credit_notes {
      ...CreditNoteFrag
    }
    supplier_expense_gst_auto_calculated
    buyer_expense_gst_auto_calculated
    expense_taxes {
      id
      amount
      role
      percentage
      tax_name
    }
    taxes {
      id
      amount
      percentage
      role
      tax_name
    }
    seller_gst_attachments {
      id
      media {
        id
        kind
        url
      }
    }
    buyer_gst_attachments {
      id
      media {
        id
        kind
        url
      }
    }
  }
  ${BASE_USER_FRAG}
  ${EXPENSE_FRAG}
  ${RESULT_BASE_FRAG}
  ${ADVANCE_PAYMENT_FRAG}
  ${CREDIT_NOTE_FRAG}
`

export const TRADE_DETAIL_FRAG2 = /* GraphQL */ `
  fragment TradeDetailFrag2 on trade {
    id
    status: current_status_id
    tracking_code
    advance_po
    over_draft {
      id
      status
      logs(order_by: { created_at: desc }, limit: 1) {
        id
        status
        user {
          name
        }
      }
    }

    officer {
      id
      user {
        ...BaseUserFrag
      }
    }
    junior_officer {
      id
      user {
        ...BaseUserFrag
      }
    }
    status_processing
    receipt_id
    trip {
      id
    }
    department {
      id
      name
      reference_id
    }
    invoice {
      id
    }
    vehicle {
      id
      name
      codename: reference_id
    }
    trades(
      where: { kind: { _in: ["final", "inward", "booking"] } }
      order_by: { created_at: desc_nulls_last }
    ) {
      id
      kind
      start_date
    }
    demand_id
    offer_id
    parent_trade {
      id
      kind
      start_date
      demand_id
      offer_id
      is_multiple_commodity

      officer {
        id
        user {
          ...BaseUserFrag
        }
      }
      junior_officer {
        id
        user {
          ...BaseUserFrag
        }
      }
    }
    buyer {
      id
      credits(where: { status_id: { _eq: "Active" } }) {
        over_drafts_aggregate(
          where: {
            status: { _nin: ["Deviation Approved", "Deviation Rejected"] }
          }
        ) {
          aggregate {
            count
          }
        }
      }
      user {
        ...BaseUserFrag
      }
    }
    seller {
      id
      user {
        ...BaseUserFrag
      }
    }
    commodity {
      id
      commodity {
        ...KiteCommodityFrag
      }
    }
    commodity_variety {
      id
      commodity_variety {
        ...KiteCommodityVarietyFrag
      }
    }
    facilitator {
      id
      facilitator {
        id
        name
        codename
      }
    }
    plot_crop {
      id
      plot_crop {
        id
        external_reference_id
        tag
        name
        codename
      }
    }
    attachments {
      id
      media {
        id
        etag
        url
        key
        kind
      }
    }
    standard_deduction
    start_date
    end_date
    expiry
    packaging
    seller_tnc
    buyer_tnc
    seller_verification
    buyer_verification
    mode
    kind
    total_amount
    total_quantity
    deducted_amount
    supplier_charge
    seller_tds
    seller_tds_percentage
    buyer_expense_amount
    seller_expense_amount
    deducted_quantity
    expense_amount
    is_multiple_commodity
    #supplier_gst_auto_calculated
    #buyer_gst_auto_calculated
    trade_items_aggregate {
      aggregate {
        sum {
          returned_quantity
        }
      }
    }
    trade_items {
      id
      result {
        id
        codename
        result {
          ...ResultBaseFrag
        }
      }
      quantity
      quantity_unit {
        id
        si_unit {
          id
          name
          codename
          base_conversion
        }
      }
      commodity {
        id
        commodity {
          ...KiteCommodityFrag
        }
      }
      commodity_variety {
        id
        commodity_variety {
          ...KiteCommodityVarietyFrag
        }
      }
      plot_crop {
        id
        plot_crop {
          id
          external_reference_id
          tag
          name
          codename
        }
      }
      variety_grade {
        id
        variety_grade {
          id
          name
          codename
        }
      }
      rate
      total_amount: amount
      daily_rate
      rate_unit {
        id
        si_unit {
          id
          name
          codename
          base_conversion
        }
      }
      supplier_gst_auto_calculated
      buyer_gst_auto_calculated
      taxes {
        id
        amount
        role
        percentage
        tax_name
      }
    }
    expenses {
      ...ExpenseFrag
    }
    advance_payments {
      ...AdvancePayFrag
    }
    credit_notes {
      ...CreditNoteFrag
    }
    taxes {
      id
      amount
      percentage
      role
      tax_name
    }
    seller_gst_attachments {
      id
      media {
        id
        kind
        url
      }
    }
    buyer_gst_attachments {
      id
      media {
        id
        kind
        url
      }
    }
  }
  ${BASE_USER_FRAG}
  ${EXPENSE_FRAG}
  ${RESULT_BASE_FRAG}
  ${ADVANCE_PAYMENT_FRAG}
  ${CREDIT_NOTE_FRAG}
`

export const TRADE_HASHES = /* GraphQL */ `
  query TradeHashes($id: bigint!) {
    trade_by_pk(id: $id) {
      id
      seller_hash
      buyer_hash
    }
  }
`
export const TRADES_HASHES = /* GraphQL */ `
  query TradesHashes($ids: [bigint!]!) {
    trade(where: { id: { _in: $ids } }) {
      id
      seller_hash
      buyer_hash
    }
  }
`
export const ALL_TRADE_REQUESTS_IDS = /* GraphQL */ `
  query AllTradeRequestsIds(
    $where: trade_bool_exp
    $limit: Int
    $offset: Int
    $order_by: [trade_order_by!]
  ) {
    trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
      id
      kind
      current_status_id
      department {
        id
        name
        reference_id
      }
    }
  }
`

export const ALL_TRADE_REQUESTS = /* GraphQL */ `
  query AllTradeRequests(
    $where: trade_bool_exp
    $limit: Int
    $offset: Int
    $order_by: [trade_order_by!]
  ) {
    trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
      id
      advance_po
      status_processing
      action_logs(where: { change_message: { _ilike: "Trade Confirmed" } }) {
        id
        change_message
        created_by {
          full_name
        }
      }
      credit: issuance_notes(
        order_by: { created_at: desc_nulls_last }
        where: { type: { _eq: "CREDIT" } }
        limit: 1
      ) {
        id
        is_verified
      }
      debit: issuance_notes(
        order_by: { created_at: desc_nulls_last }
        where: { type: { _eq: "DEBIT" } }
        limit: 1
      ) {
        id
        is_verified
      }
      over_draft {
        id
        amount
      }
      department {
        id
        name
        reference_id
      }
      receipt_id
      trip {
        id
      }
      invoice {
        id
        current_status_id
      }
      parent_trade {
        id
        demand_id
        offer_id
      }
      tracking_code
      created_at
      kind
      is_multiple_commodity
      seller_verification
      buyer_verification
      total_amount
      total_quantity
      deducted_amount
      deducted_quantity
      deducted_quantity_remaining
      expense_amount
      standard_deduction
      seller {
        id
        user {
          id
          full_name
          number
          is_blocked
          external_reference_id
          current_address {
            id
            village
          }
        }
      }
      trades_aggregate {
        aggregate {
          sum {
            total_quantity
          }
        }
      }
      buyer {
        id
        user {
          id
          is_blocked
          full_name
          external_reference_id
        }
      }

      commodity {
        id
        name
      }
      commodity_variety {
        id
        name
      }
      item_units: trade_items(limit: 1) {
        id
        quantity_unit {
          id
          name
          reference_id
        }
        rate_unit {
          id
          name
          reference_id
        }
      }
      trade_items(order_by: { variety_grade: { name: asc_nulls_last } }) {
        id
        rate
        commodity {
          id
          name
        }
        commodity_variety {
          id
          name
        }
        variety_grade {
          id
          name
        }
        quantity
        quantity_unit {
          id
          name
        }
        rate_unit {
          id
          name
        }
        amount
      }
      trade_items_aggregate {
        aggregate {
          sum {
            quantity
            returned_quantity
          }
          avg {
            rate
          }
        }
      }
      total_amount
      created_by {
        id
        full_name
        photo {
          id
          url
        }
      }
      current_status_id
      updated_at
    }
    trade_statuses: trade_aggregate(
      where: $where
      distinct_on: [current_status_id]
    ) {
      aggregate {
        count
        min {
          current_status_id
        }
      }
    }
    trade_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`

export const TRADE_LIST_SELECTOR = /* GraphQL */ `
  query TradeListSelector(
    $where: trade_bool_exp
    $limit: Int
    $offset: Int
    $order_by: [trade_order_by!]
  ) {
    trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
      id
      advance_po
      status_processing
      department {
        id
        name
        reference_id
      }
      buyer_bifurcation {
        deducted_amount {
          op
          val
        }
        buyer_expense_amount {
          op
          val
        }
        buyer_expense_tax_amount {
          op
          val
        }
        buyer_debit_note_amount {
          op
          val
        }
        buyer_credit_note_amount {
          op
          val
        }
        buyer_tax_amount {
          op
          val
        }
        received_amount {
          op
          val
        }
        total
      }
      total_amount
      total_quantity
      deducted_amount
      deducted_quantity
      deducted_quantity_remaining
      expense_amount
      standard_deduction
      supplier_charge
      seller {
        id
        user {
          id
          full_name
          number
          is_blocked
          external_reference_id
        }
      }
      buyer {
        id
        user {
          id
          is_blocked
          full_name
          external_reference_id
        }
      }
      item_units: trade_items(limit: 1) {
        id
        quantity_unit {
          id
          name
          reference_id
        }
        rate_unit {
          id
          name
          reference_id
        }
      }
      trade_items(order_by: { variety_grade: { name: asc_nulls_last } }) {
        id
        rate
        commodity {
          id
          name
        }
        commodity_variety {
          id
          name
        }
        variety_grade {
          id
          name
        }
        quantity
        amount
        taxes(where: { role: { _eq: "buyer" } }) {
          id
          amount
          percentage
          role
          tax_name
        }
      }
      total_amount

      current_status_id
      updated_at
    }
  }
`

export const ALL_TRADE_REQUESTS_STATUS = /* GraphQL */ `
  subscription AllTradeRequestsStatus(
    $where: trade_bool_exp
    $limit: Int
    $offset: Int
    $order_by: [trade_order_by!]
  ) {
    trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
      id
      current_status_id
      status_processing
    }
  }
`

export const UPSERT_TRADE = /* GraphQL */ `
  mutation UpsertTrade($input: TradeInput!) {
    add_update_trade(input: $input) {
      trade {
        id
      }
    }
  }
  ${TRADE_DETAIL_FRAG2}
`

export const UPDATE_TRADE_ATTACHEMNTS = /* GraphQL */ `
  mutation UpdateTradeAttachments($input: trade_insert_input!) {
    insert_trade_one(
      object: $input
      on_conflict: { constraint: trade_pkey, update_columns: [packaging] }
    ) {
      id
    }
  }
`

export const BROADCAST_CONSENT = /* GraphQL */ `
  mutation BroadcastConsent(
    $trade_id: ID!
    $send_to_buyer: Boolean
    $send_to_seller: Boolean
  ) {
    broadcast_consents(
      trade_id: $trade_id
      send_to_buyer: $send_to_buyer
      send_to_seller: $send_to_seller
    ) {
      buyer_status
      seller_status
    }
  }
`

export const TRADE_DETAIL = /* GraphQL */ `
  query TradeDetail($id: bigint!) {
    trade_by_pk(id: $id) {
      ...TradeDetailFrag
    }
  }
  ${BASE_USER_FRAG}
`

// export const DELETE_TRADE_ITEM = gql`
//   mutation DeleteTradeItem($id: bigint!) {
//     delete_trade_item_by_pk(id: $id) {
//       id
//       trade {
//         id
//         trade_items {
//           id
//         }
//       }
//     }
//   }
//   ${TRADE_DETAIL_FRAG}
// `

export const UPDATE_TRADE_ITEM = gql`
  mutation UpdateTrade($id: bigint!, $_set: trade_set_input) {
    update_trade_by_pk(pk_columns: { id: $id }, _set: $_set) {
      ...TradeDetailFrag
    }
  }
  ${TRADE_DETAIL_FRAG}
`

export const INCREMENT_TRADE_ITEM = /* GraphQL */ `
  mutation IncrementTradeCounter($id: bigint!) {
    update_trade_by_pk(
      pk_columns: { id: $id }
      _inc: { trade_amounts_counter: 1 }
    ) {
      id
      trade_amounts_counter
    }
  }
`

export const GET_FINAL_TRADE_LIST = gql`
  query FinalTradeList($parentId: bigint) {
    trade(
      where: { parent_trade_id: { _eq: $parentId } }
      order_by: { created_at: desc_nulls_last }
    ) {
      id
      kind
      parent_trade {
        id
        kind
        start_date
        demand_id
        offer_id
      }
      start_date
      demand_id
      offer_id
      trades {
        id
        kind
        start_date
      }
    }
  }
`

export const UPDATE_TRADE = /* GraphQL */ `
  mutation BulkUpdateTrade($where: trade_bool_exp!, $set: trade_set_input!) {
    update_trade(where: $where, _set: $set) {
      returning {
        id
        current_status_id
        status_processing
      }
      affected_rows
    }
  }
`
export const TRADE_ADVANCE_PENDING_STATUS = /* GraphQL */ `
  query TradeAdvancePendingStatus($ids: [bigint!]!) {
    trade(where: { id: { _in: $ids } }) {
      id
      current_status_id
      advance_payments {
        id
        is_verified
      }
    }
  }
`
export const BOOKING_TRADE_SUMMARY = /* GraphQL */ `
  query BookingTradeSummary($id: Int!) {
    trade_grade_quantity_summary_report(trade_id: $id) {
      more_trade
      grade_summary {
        variety_grade_id
        remaining_quantity
        booked_quantity
        variety_grade_name
      }
    }
  }
`

export const EXPENSE_CONFIG_VERSIONS = /* GraphQL */ `
  query ExpenseConfigVersions($department: ID, $kind: String!, $mode: String!) {
    expense_config_versions(department: $department, kind: $kind, mode: $mode) {
      version_id
      name
      kind
      mode
    }
  }
`
export const ADVANCE_PAYMENT_PARAMETERS = /* GraphQL */ `
  query AdancedPaymentParameters {
    advance_payment_parameters {
      id
      name
    }
  }
`

export const EXPENSE_CONFIGS = /* GraphQL */ `
  query ExpenseConfigs(
    $version: ID
    $department: ID!
    $kind: String!
    $mode: String!
  ) {
    expense_configs(
      version: $version
      department: $department
      kind: $kind
      mode: $mode
    ) {
      id
      paid_by
      expense_parameter {
        id
        name
      }
      kind
      value
    }
  }
`

export const TRADE_SUMMARY = /* GraphQL */ `
  query GradeQuantitySummary($id: bigint, $grade: String) {
    booked_quantity: trade_item_aggregate(
      where: {
        trade: { parent_trade_id: { _eq: $id } }
        variety_grade: { codename: { _eq: $grade } }
      }
    ) {
      aggregate {
        sum {
          quantity
        }
      }
    }
    total_quantity: trade_item_aggregate(where: { trade_id: { _eq: 1182 } }) {
      aggregate {
        sum {
          quantity
        }
      }
    }
  }
`

export const TRADE_SELECTOR = /* GraphQL */ `
  query TradeSelector(
    $where: trade_bool_exp
    $limit: Int
    $offset: Int
    $order_by: [trade_order_by!]
  ) {
    trade(where: $where, limit: $limit, offset: $offset, order_by: $order_by) {
      id
      created_at
      kind
      total_amount
      total_quantity
      deducted_amount
      deducted_quantity
      expense_amount
      standard_deduction
      deducted_quantity_remaining
      trades_aggregate {
        aggregate {
          sum {
            total_quantity
          }
        }
      }
      buyer {
        id
        user {
          id
          is_blocked
          full_name
          external_reference_id
        }
      }

      seller {
        id
        user {
          id
          is_blocked
          full_name
          external_reference_id
        }
      }

      commodity {
        id
        name
      }
      commodity_variety {
        id
        name
      }
      item_units: trade_items(limit: 1) {
        id
        quantity_unit {
          id
          name
          reference_id
        }
        rate_unit {
          id
          name
          reference_id
        }
      }
      trade_items(order_by: { variety_grade: { name: asc_nulls_last } }) {
        id
        rate
        variety_grade {
          id
          name
        }
        quantity
        amount
      }
      trade_items_aggregate {
        aggregate {
          sum {
            quantity
          }
          avg {
            rate
          }
        }
      }
      total_amount
      updated_at
    }
    trade_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`

// export const DUMP_TRADES = /* GraphQL */ `
//   mutation DumpTrade($trade_ids: [ID!]!) {
//     delete_trades(trade_ids: $trade_ids) {
//       message
//       errors
//     }
//   }
// `

export const DELETE_SELLER_GST_ATTACHMENTS = /* GraphQL */ `
  mutation DeleteSellerGstAttachments($media_id: [bigint!]!, $id: Int!) {
    delete_trade_seller_gst_attachments(where: { id: { _in: $media_id } }) {
      returning {
        id
      }
    }
    delete_media_by_pk(id: $id) {
      id
    }
  }
`

export const DELETE_BUYER_GST_ATTACHMENTS = /* GraphQL */ `
  mutation DeleteBuyerGstAttachments($media_id: [bigint!]!, $id: Int!) {
    delete_trade_buyer_gst_attachments(where: { id: { _in: $media_id } }) {
      returning {
        id
      }
    }
    delete_media_by_pk(id: $id) {
      id
    }
  }
`
